export const TURNORDER_GAME_DB_KEY = '2-4-turnOrderGameState'
